export const userRoles = {
  admin: 'Admin',
  observer: 'Observer',
};
